import {
  PAYMENT_METHODS,
  PROMOTION_DURATION,
  PROMOTION_TYPE,
  PROMOTION_TYPE_AND_DURATION_TO_VALUE,
} from '../constants/payment.constants';
import { formatMoney } from './currency';

export const getPaymentMethods = (isPrivateUser, intl) =>
  isPrivateUser
    ? [
        {
          value: PAYMENT_METHODS.PRIVATE.MONTHLY,
          price: '9,50 EUR',
          descriptionList: [
            intl.formatMessage({
              id: 'General.paymentMethods.description.oneListingOnMarketplace',
            }),
            intl.formatMessage({
              id: 'General.paymentMethods.description.automaticRenewalOneMonth',
            }),
            intl.formatMessage({ id: 'General.paymentMethods.description.allPromotionsAvailable' }),
            intl.formatMessage({ id: 'General.paymentMethods.description.youCanUnsubscribe' }),
          ],
        },
        {
          value: PAYMENT_METHODS.PRIVATE.QUARTERLY,
          price: '24,50 EUR',
          descriptionList: [
            intl.formatMessage({
              id: 'General.paymentMethods.description.oneListingOnMarketplace',
            }),
            intl.formatMessage(
              { id: 'General.paymentMethods.description.automaticRenewal' },
              { value: 3 }
            ),
            intl.formatMessage({ id: 'General.paymentMethods.description.allPromotionsAvailable' }),
            intl.formatMessage(
              { id: 'General.paymentMethods.description.saved' },
              { value: '6,38' }
            ),
            intl.formatMessage({ id: 'General.paymentMethods.description.youCanUnsubscribe' }),
          ],
        },
        {
          value: PAYMENT_METHODS.PRIVATE.SEMI_ANNUAL,
          price: '39,50 EUR',
          isBestChoice: true,
          descriptionList: [
            intl.formatMessage({
              id: 'General.paymentMethods.description.oneListingOnMarketplace',
            }),
            intl.formatMessage(
              { id: 'General.paymentMethods.description.automaticRenewal' },
              { value: 6 }
            ),
            intl.formatMessage({ id: 'General.paymentMethods.description.allPromotionsAvailable' }),
            intl.formatMessage(
              { id: 'General.paymentMethods.description.saved' },
              { value: '22,25' }
            ),
            intl.formatMessage({ id: 'General.paymentMethods.description.youCanUnsubscribe' }),
          ],
        },
      ]
    : [
        {
          value: PAYMENT_METHODS.BUSINESS.BASIC,
          price: '25,- EUR',
          pricePer: intl.formatMessage({ id: `General.paymentMethods.pricePer` }),
          descriptionList: [
            intl.formatMessage({
              id: 'General.paymentMethods.description.business-basic.benefit1',
            }),
            intl.formatMessage({
              id: 'General.paymentMethods.description.business-basic.benefit2',
            }),
            intl.formatMessage({
              id: 'General.paymentMethods.description.business-basic.benefit3',
            }),
            intl.formatMessage({
              id: 'General.paymentMethods.description.business-basic.benefit4',
            }),
            intl.formatMessage({
              id: 'General.paymentMethods.description.business-basic.benefit5',
            }),
          ],
          footnote: intl.formatMessage({
            id: 'General.paymentMethods.description.business-basic.footnote',
          }),
        },
        {
          value: PAYMENT_METHODS.BUSINESS.PRO,
          price: '40,- EUR',
          pricePer: intl.formatMessage({ id: `General.paymentMethods.pricePer` }),
          descriptionList: [
            intl.formatMessage({ id: 'General.paymentMethods.description.business-pro.benefit1' }),
            intl.formatMessage({ id: 'General.paymentMethods.description.business-pro.benefit2' }),
            intl.formatMessage({ id: 'General.paymentMethods.description.business-pro.benefit3' }),
            intl.formatMessage({ id: 'General.paymentMethods.description.business-pro.benefit4' }),
            intl.formatMessage({ id: 'General.paymentMethods.description.business-pro.benefit5' }),
          ],
          footnote: intl.formatMessage({
            id: 'General.paymentMethods.description.business-pro.footnote',
          }),
        },
      ];

export const getPromotionOptions = (intl, prices, duration = PROMOTION_DURATION.WEEKLY) => [
  {
    value: PROMOTION_TYPE.RECURRING.HIGHLIGHT,
    price: formatMoney(
      intl,
      prices?.[PROMOTION_TYPE_AND_DURATION_TO_VALUE[PROMOTION_TYPE.RECURRING.HIGHLIGHT][duration]]
    ),
    pricePer: intl.formatMessage({
      id: `General.promotion.duration.${duration}`,
    }),
    descriptionList: [
      intl.formatMessage({
        id: 'General.promotion.description.higherAttention',
      }),
      intl.formatMessage({
        id: 'General.promotion.description.moreClicks',
      }),
    ],
  },
  {
    value: PROMOTION_TYPE.RECURRING.RECOMMENDED,
    price: formatMoney(
      intl,
      prices?.[PROMOTION_TYPE_AND_DURATION_TO_VALUE[PROMOTION_TYPE.RECURRING.RECOMMENDED][duration]]
    ),
    pricePer: intl.formatMessage({
      id: `General.promotion.duration.${duration}`,
    }),
    descriptionList: [
      intl.formatMessage({
        id: 'General.promotion.description.listedInTheRecommendedSection',
      }),
      intl.formatMessage({
        id: 'General.promotion.description.reachSeriousBuyers',
      }),
      intl.formatMessage({
        id: 'General.promotion.description.higherExposure',
      }),
    ],
  },
  {
    value: PROMOTION_TYPE.RECURRING.HIGHLIGHT_RECOMMENDED,
    price: formatMoney(
      intl,
      prices?.[
        PROMOTION_TYPE_AND_DURATION_TO_VALUE[PROMOTION_TYPE.RECURRING.HIGHLIGHT_RECOMMENDED][
          duration
        ]
      ]
    ),
    pricePer: intl.formatMessage({
      id: `General.promotion.duration.${duration}`,
    }),
    descriptionList: [
      intl.formatMessage({
        id: 'General.promotion.description.bestOfBoth',
      }),
      intl.formatMessage({
        id: 'General.promotion.description.fasterSales',
      }),
    ],
  },
];
